import React from "react"
import Navbar from "../bootstrap/navbar"
import Container from "../bootstrap/container"
import Nav from "../bootstrap/nav"
import NavItem from "../bootstrap/nav_item"
import {navigate} from "gatsby"
import {astext} from "./sub-navigation.module.scss"

const SubNavPost = props => {
  return (
    <Navbar
      id="nav-sub-post"
      bg="lsu-light-purple"
      variant="dark"
      expand={true}
    >
      <Container>
      <Nav as="ul">
      <NavItem as="li" className={`py-1 fs-4`}>
          <button onClick={()=> navigate(-1)} className={`${astext}`}>
          &lt; Previous
          </button>
        </NavItem>
      </Nav>
       
      </Container>
    </Navbar>
  )
}
export default SubNavPost